import { configureIguazuSSR } from 'iguazu-holocron';
import { getProduct } from 'axp-product-ducks';
import { prefetchExperimentsV2 } from '@americanexpress/one-xp-client-sdk';
import { loadLanguagePack, updateLocale } from '@americanexpress/one-app-ducks';

import { setIsAAM, setIsHighVolGuid } from '../ducks/highVolAamReducer';
import { moduleName } from '../constants';

export const getIsAAM = (selectedProduct) => selectedProduct?.authorized_user_profile?.roles?.some(
  (role) => ['AUTHORIZED_MANAGER_FULL', 'AUTHORIZED_MANAGER_PARTIAL'].includes(role.toUpperCase()));

export const experimentWithTimeout = (dispatch, timeout) => new Promise((resolve, reject) => {
  // Set up the timeout rejection
  const experimentTimeout = setTimeout(() => {
    reject(new Error('Experiment prefetch timed out'));
  }, timeout);

  // Dispatch the experiment and clear the timeout on success
  dispatch(prefetchExperimentsV2())
    .then((data) => {
      clearTimeout(experimentTimeout);
      resolve(data);
    })
    .catch((error) => {
      clearTimeout(experimentTimeout);
      reject(error);
    });
});

export default async function loadModuleData({ store, module, ownProps }) {
  const { dispatch, getState } = store;
  const state = getState();
  const activeLocale = state.getIn(['intl', 'activeLocale']);
  const caseCheckLocale = activeLocale.replace(/-.*/g, (region) => region.toUpperCase());
  if (caseCheckLocale !== activeLocale) {
    await dispatch(updateLocale(caseCheckLocale));
  }
  if (!global.BROWSER) {
    const highVolGuidList = state.getIn(['config', 'highVolPubGuids'], []);
    const publicGuid = state.getIn(['browser', 'cookies', 'blueboxpublic']);
    if (highVolGuidList.includes(publicGuid)) await dispatch(setIsHighVolGuid(true));
    if (getIsAAM(getProduct(state))) await dispatch(setIsAAM(true));
  }

  const allPromises = await Promise.all([
    configureIguazuSSR({ store, module, ownProps }),
    dispatch(loadLanguagePack(moduleName, { fallbackLocale: 'en-US' })),
    experimentWithTimeout(dispatch, 1000),
  ]);
  return allPromises;
}
